export function attachFilterListeners() {
    document.addEventListener('click', (event) => {
        if (event.target.classList.contains('tags-filter-option')) {
            const value = event.target.getAttribute('data-value');
            this.currentFilters.tags = value;
            this.updateFilterButtonText('tags-filter-text', event.target.textContent);
            document.getElementById('tags-filter-menu')?.classList.add('hidden');
            this.resetToFirstPage();
            this.loadCollections();
        }

        if (event.target.classList.contains('visibility-filter-option')) {
            const value = event.target.getAttribute('data-value');
            this.currentFilters.visibility = value;
            this.updateFilterButtonText('visibility-filter-text', event.target.textContent);
            document.getElementById('visibility-filter-menu')?.classList.add('hidden');
            this.resetToFirstPage();
            this.loadCollections();
        }

        if (event.target.classList.contains('sort-filter-option')) {
            const value = event.target.getAttribute('data-value');
            this.currentFilters.sort = value;
            this.updateFilterButtonText('sort-filter-text', event.target.textContent);
            document.getElementById('sort-filter-menu')?.classList.add('hidden');
            this.resetToFirstPage();
            this.loadCollections();
        }
    });

    document.getElementById('clear-all-filters')?.addEventListener('click', () => {
        this.clearAllFilters();
    });
}

export function updateFilterButtonText(elementId, text) {
    const element = document.getElementById(elementId);
    if (element) {
        element.textContent = text;
    }
}

export function clearAllFilters() {
    this.currentFilters = {
        search: '',
        tags: '',
        visibility: '',
        sort: 'created_desc'
    };

    if (this.searchInput) {
        this.searchInput.value = '';
    }

    this.updateFilterButtonText('tags-filter-text', 'Tags');
    this.updateFilterButtonText('visibility-filter-text', 'Trạng thái');
    this.updateFilterButtonText('sort-filter-text', 'Sắp xếp');

    this.resetToFirstPage();
    this.loadCollections();
}
